import { type PaletteOptions, type SimplePaletteColorOptions } from "@mui/material";
import { type ThemeOptions } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";
import { typographyMixin } from "@pmag/ui-components";
import { isButtonVariant } from "@pmag/ui-components/lib/src/components/buttons/button/Button.utils";
import { getCommonButtonStyles } from "@pmag/ui-components/lib/src/components/buttons/commonButtonStyles";
import { paletteOptions } from "@pmag/ui-components/lib/src/theme/pmagThemeOptions";

const primaryColors: SimplePaletteColorOptions = {
    contrastText: "#FFFFFF",
    dark: "#006C7D",
    light: "#33AFC3",
    main: "#009BB4",
};

const mergedPaletteOptions: PaletteOptions = deepmerge<PaletteOptions>(paletteOptions, { primary: primaryColors });

export const cfMotoThemeOptions: ThemeOptions = {
    palette: mergedPaletteOptions,
    shape: {
        borderRadius: 0,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState, theme }) => {
                    if (isButtonVariant(ownerState.variant)) {
                        return {
                            ...typographyMixin(theme, "body-short-01"),
                            ...getCommonButtonStyles(theme, ownerState.variant),
                            borderRadius: 20,
                        };
                    }

                    return {};
                },
            },
        },
    },
};
